/**
 * OVERRIDE View.jsx
 * REASON: Add IPN styling and frontpage variation.
 */

import SliderView from '../../../../components/Blocks/Slider/DefaultSliderView';

export default SliderView;
